import { IconButton } from '@dev-spendesk/grapes';
import cx from 'classnames';
import { type ReactNode } from 'react';

import styles from './SidePanel.module.css';
import { useTranslation } from '../../hooks/useTranslation';

type Props = {
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  isOpened?: boolean;
  onClose?: () => void;
};

export const SidePanel = ({
  children,
  footer,
  className,
  isOpened = false,
  onClose,
}: Props) => {
  const { t } = useTranslation('global');
  return (
    <div
      className={cx(styles.root, className, {
        [styles.rootIsOpened]: isOpened,
      })}
      data-testid="test__sidePanel"
    >
      <div className={styles.inner}>
        {onClose && (
          <IconButton
            className={styles.closeIcon}
            iconName="cross"
            onClick={onClose}
            aria-label={t('misc.close')}
          />
        )}
        {children}
      </div>
      {footer && <footer className={styles.footer}>{footer}</footer>}
    </div>
  );
};
